import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';

import { UserMetadataComponent } from '../pages/user-metadata/user-metadata.component';

export const AUTH_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: 'auth/metadata',
        component: UserMetadataComponent,
        data: { title: 'User Authentication Metadata' },
        canActivate: [AuthGuard]
      }
    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(AUTH_ROUTES)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
